
import React from 'react';
import Rendezvous2024 from 'views/Rendezvous2024';

const RentalPage = () => {
  return <Rendezvous2024 />;
};

export default RentalPage;
